import { connect } from "react-redux"

import {
    communityListInvalidationRequest,
    communityListSearchRequest,
    communitySetFilter,
    communityAddNew
} from "../../../actions/community-actions"
import CommunityListWidget from "./CommunityListWidget"

const mapStateToProps = ({
    presentation: { communities },
    paging,
    authentication: { permissions }
}) => ({
    isFetching: communities.isFetchingList || communities.isFetchingItem,
    pagingRequest: paging.communities[communities.searchCriteria] || {},
    canAdd: permissions.indexOf("w_community") !== -1,
    nameSearch: communities.workingFilterModel.name
})

const mapDispatchToProps = dispatch => ({
    invalidate: pagingRequest => () =>
        dispatch(communityListInvalidationRequest(pagingRequest)),
    onFilterSelect: () => dispatch(communitySetFilter(true)),
    onSearch: ({ target: { name, value } }) =>
        dispatch(communityListSearchRequest(name, value)),
    addNewCommunity: () => dispatch(communityAddNew())
})

export default connect(mapStateToProps, mapDispatchToProps)(CommunityListWidget)
